module.exports = __webpack_public_path__ + "fonts/b8704ee53e5a4cd08ba7a6e9334b6149.woff2";